import { render, staticRenderFns } from "./DisplayGroupInfo.vue?vue&type=template&id=06af91f8&scoped=true&"
import script from "./DisplayGroupInfo.vue?vue&type=script&lang=ts&"
export * from "./DisplayGroupInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af91f8",
  null
  
)

export default component.exports